import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { BellRing, Loader2 } from "lucide-react";
import { INSURANCE_TYPES } from "../lib/site";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const inputCls =
  "w-full rounded-xl border border-navy/10 bg-white px-4 py-3.5 text-sm text-navy placeholder:text-charcoal/40 outline-none transition-colors duration-200 focus:border-mint focus:ring-2 focus:ring-mint/20";

export default function ReminderForm() {
  const [form, setForm] = useState({ name: "", phone: "", insurance_type: "", expiry_date: "", note: "" });
  const [loading, setLoading] = useState(false);
  const today = new Date().toISOString().split("T")[0];

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/reminders`, form);
      toast.success("Reminder set! We'll call you before your renewal is due.");
      setForm({ name: "", phone: "", insurance_type: "", expiry_date: "", note: "" });
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Something went wrong. Please try again or call us.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} className="grid gap-4 sm:grid-cols-2" data-testid="reminder-form">
      <input required minLength={2} placeholder="Full Name" value={form.name} onChange={set("name")} className={inputCls} data-testid="reminder-name" aria-label="Full Name" />
      <input required type="tel" minLength={10} placeholder="Mobile Number" value={form.phone} onChange={set("phone")} className={inputCls} data-testid="reminder-phone" aria-label="Mobile Number" />
      <select required value={form.insurance_type} onChange={set("insurance_type")} className={`${inputCls} ${form.insurance_type ? "" : "text-charcoal/40"}`} data-testid="reminder-type" aria-label="Policy Type">
        <option value="" disabled>Policy Type</option>
        {INSURANCE_TYPES.map((t) => (
          <option key={t} value={t}>{t}</option>
        ))}
      </select>
      <div>
        <input required type="date" min={today} value={form.expiry_date} onChange={set("expiry_date")} className={`${inputCls} ${form.expiry_date ? "" : "text-charcoal/40"}`} data-testid="reminder-date" aria-label="Policy Expiry Date" />
        <p className="mt-1.5 pl-1 text-xs text-charcoal/50">Policy expiry date</p>
      </div>
      <input placeholder="Note (optional) — e.g. vehicle number" value={form.note} onChange={set("note")} className={`${inputCls} sm:col-span-2`} data-testid="reminder-note" aria-label="Note" />
      <div className="sm:col-span-2">
        <button
          type="submit"
          disabled={loading}
          className="group flex w-full items-center justify-center gap-2 rounded-full bg-mint py-4 text-base font-bold text-white shadow-mint transition-all duration-200 hover:-translate-y-0.5 hover:bg-mint-600 disabled:opacity-60"
          data-testid="reminder-submit"
        >
          {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : <BellRing className="h-4 w-4" />}
          {loading ? "Setting..." : "Remind Me Before Renewal"}
        </button>
        <p className="mt-3 text-center text-xs text-charcoal/50" data-testid="reminder-privacy-note">
          Your details will only be used to call you back about your renewal.
        </p>
      </div>
    </form>
  );
}
